module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("应用编辑")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上传应用")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    staticClass: "uploadAPK",
    attrs: {
      "show-upload-list": false,
      "action": "/zm/cos/upload",
      "accept": ".apk",
      "format": ['apk'],
      "before-upload": _vm.checkApkUpload,
      "on-success": _vm.apkUploadSuccess,
      "on-error": _vm.apkUploadFail,
      "on-remove": _vm.removeAPK,
      "on-progress": _vm.handleApkUpload,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize
    }
  }, [_c('div', [(_vm.apkProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "点击上传APK"
    },
    model: {
      value: (_vm.apkName),
      callback: function($$v) {
        _vm.apkName = $$v
      },
      expression: "apkName"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用logo")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.logoUpload), function(item) {
    return _c('div', {
      staticClass: "logo-upload-list"
    }, [
      [_c('img', {
        attrs: {
          "src": item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "logo-upload-list-cover"
      }, [_c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-eye-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleLogoView.apply(null, arguments)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-trash-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleLogoRemove.apply(null, arguments)
          }
        }
      })], 1)]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".jpg,.jpeg,.png",
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "on-progress": _vm.handleLogoUpload,
      "on-error": _vm.logoUploadFail,
      "on-success": _vm.logoUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkLogoUpload,
      "type": "drag",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logoUpload.length < 1),
      expression: "logoUpload.length < 1"
    }],
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "line-height": "100px"
    }
  }, [(_vm.logoProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览"
    },
    model: {
      value: (_vm.logoVisible),
      callback: function($$v) {
        _vm.logoVisible = $$v
      },
      expression: "logoVisible"
    }
  }, [(_vm.logoVisible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.formItem.appLogo
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("需上传完整正方形图标，尺寸：216*216px")])], 2)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称..."
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("包名")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "填写包名，如：mobi.accessible.qimingxing"
    },
    model: {
      value: (_vm.formItem.packageName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "packageName", $$v)
      },
      expression: "formItem.packageName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("Appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "微信开发平台应用展示的AppID"
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品id..."
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用版本")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入版本号，如V1.0.1"
    },
    model: {
      value: (_vm.formItem.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appVersion", $$v)
      },
      expression: "formItem.appVersion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上架时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "datetime",
      "clearable": "",
      "placeholder": "选择上架时间"
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.appCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appCategory", $$v)
      },
      expression: "formItem.appCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("启明应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("启明游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("其他应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("其他游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("未分类")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 30,
      "placeholder": "请输入一句话简介，限30字"
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 2000,
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "应用介绍，20-2000字之间"
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示视频")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.videoUpload), function(item) {
    return _c('div', [
      [_c('video', {
        staticStyle: {
          "width": "200px",
          "height": "300px"
        },
        attrs: {
          "controls": "controls",
          "src": item
        }
      }), _vm._v(" "), _c('Button', {
        staticStyle: {
          "margin-bottom": "30px"
        },
        on: {
          "click": _vm.removeVideo
        }
      }, [_vm._v("删除视频")])]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".mp4",
      "format": ['mp4'],
      "on-error": _vm.videoUploadFail,
      "on-remove": _vm.removeVideo,
      "on-progress": _vm.handleVideoUpload,
      "on-success": _vm.videoUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkVideoUpload,
      "type": "drag",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoUpload.length < 1),
      expression: "videoUpload.length < 1"
    }],
    staticStyle: {
      "width": "200px",
      "height": "300px",
      "line-height": "300px"
    }
  }, [(_vm.videoProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示截图")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.imgUpload), function(item) {
    return _c('div', {
      staticClass: "img-upload-list"
    }, [
      [_c('img', {
        attrs: {
          "src": item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-upload-list-cover"
      }, [_c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-eye-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleImgView(item)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-trash-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleImgRemove(item)
          }
        }
      })], 1)]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".jpg,.jpeg,.png",
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "on-progress": _vm.handleImgUpload,
      "on-success": _vm.imgUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkImgUpload,
      "type": "drag",
      "multiple": "",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgUpload.length < 5),
      expression: "imgUpload.length < 5"
    }],
    staticStyle: {
      "width": "200px",
      "height": "300px",
      "line-height": "300px"
    }
  }, [(_vm.imgProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览"
    },
    model: {
      value: (_vm.imgVisible),
      callback: function($$v) {
        _vm.imgVisible = $$v
      },
      expression: "imgVisible"
    }
  }, [(_vm.imgVisible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.imgShow
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("请上传最少3张截图，支持JPG\\JPEG或PNG格式，建议分辨率：450*800（9：16）,单张图片最大为2M")])], 2)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.isNew) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitTotal
    }
  }, [_vm._v("添加产品")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("提交修改")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60cfc48a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/app-blocks/editWebAppDetail.vue
// module id = ql3x
// module chunks = 0